<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('roles')">Role</inertia-link>
      <span class="text-shtax-400 font-medium">/</span> {{ form.name }}
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden md:overflow-visible max-w-3xl">
      <form @submit.prevent="update" class="z-0">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Nazwa" />

          <multiselect-input v-model="form.guard_name" :error="form.errors.guard_name" class="pr-6 pb-8 w-full lg:w-1/2" label="Przestrzeń" :options="guard_options" :multiple="false" :close_on_select="true" />

          <multiselect-input v-model="form.permission" :error="form.errors.permission" class="pr-6 pb-8 w-full lg:w-full" label="Uprawnienia" :options="options" />

        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Usuń rolę użytkownika</button>
          <loading-button :loading="form.processing" class="btn-shtax ml-auto" type="submit">Aktualizuj rolę</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'
import Swal from 'sweetalert2'

export default {
  metaInfo() {
    return {
      title: `${this.form.name}`,
    }
  },
  components: {
    LoadingButton,
    TextInput,
    MultiselectInput
  },
  layout: Layout,
  props: {
  	role: Object,
    permissions: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        name: this.role.name,
        guard_name: this.role.guard_name,
        permission: this.role.permissions.map(permission => permission.name)
      }),
      options: this.permissions,
      guard_options: ['web', 'api']
    }
  },
  methods: {
    update() {
      this.form.post(this.route('roles.update', this.role.id), {
        onSuccess: () => this.form.reset(),
      })
    },
    destroy() {
      Swal.fire({
        title: 'Jesteś pewny że chcesz usunąć wybraną rolę użytkownika?',
        text: 'Przywrócenie usuniętej roli nie będzie już możliwe',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Tak, usuń!',
        cancelButtonText: 'Nie'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(this.route('roles.destroy', this.role.id))
        }
      })
    }
  }
}
</script>
